import { addMonths } from 'date-fns'

export default {
  refreshOn: ({ selectedDate }) => ([selectedDate]),
  'Calendar.Calendar.Dates.Day': ({ date, disabled }, outlet) => {
    if (disabled) return;
    outlet({ selectedDate: date })
  },
  'Calendar.Calendar.DeleteButton': ({ }, outlet) => {
    outlet({ selectedDate: null })
  },
  'Calendar.Calendar.CalendarHeader.Selector.NextMonth': ({ month, year }, _, internalStateSetter) => {
    const nextMonth = addMonths(new Date(year, month), 1)
    internalStateSetter({ month: nextMonth.getMonth(), year: nextMonth.getFullYear() });
  },
  'Calendar.Calendar.CalendarHeader.Selector.PrevMonth': ({ month, year }, _, internalStateSetter) => {
    const lastMonth = addMonths(new Date(year, month), -1)
    internalStateSetter({ month: lastMonth.getMonth(), year: lastMonth.getFullYear() });
  },
  'Calendar.Calendar.CalendarHeader.Selector.NextYear': ({ month, year }, _, internalStateSetter) => {
    internalStateSetter({ month, year: year + 1 });
  },
  'Calendar.Calendar.CalendarHeader.Selector.PrevYear': ({ month, year }, _, internalStateSetter) => {
    internalStateSetter({ month, year: year - 1 });
  }
}